import React from 'react';
import { useProposal } from '../../../context/proposalContext/ProposalContextProvider';
import { Container } from '../../../components';
import ProductList from '../create-proposal/ProductList';
import StandardTotal from '../create-proposal/StandardTotal';

const PreviewQuote = ({ closeModal }) => {
  const { proposal } = useProposal();

  return (
    <div className="h-full bg-gray-50 p-6">
      {proposal?.customer?.id !== 0 && (
        <Container title="Proposal Preview">
          <div className="p-6 bg-white shadow-lg rounded-lg mb-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">
              Customer Details
            </h2>
            <div className="grid grid-cols-2 gap-6 text-gray-600">
              <div>
                <strong className="block font-medium text-gray-800">
                  Customer Code:
                </strong>
                {proposal.customer?.customerCode || 'N/A'}
              </div>
              <div>
                <strong className="block font-medium text-gray-800">
                  Customer Name:
                </strong>
                {proposal.customer?.customerName || 'N/A'}
              </div>
              <div>
                <strong className="block font-medium text-gray-800">
                  Proposal Attn:
                </strong>
                {proposal.quoteAttn || 'N/A'}
              </div>
              <div>
                <strong className="block font-medium text-gray-800">
                  Sales Person:
                </strong>
                {proposal.salesPerson
                  ? `${proposal.salesPerson.firstName} ${proposal.salesPerson.lastName}`
                  : 'N/A'}
              </div>
              <div>
                <strong className="block font-medium text-gray-800">
                  Close Date:
                </strong>
                {proposal.closeDate || 'N/A'}
              </div>
              <div>
                <strong className="block font-medium text-gray-800">
                  GST:
                </strong>
                {proposal.priceGstInclude ? 'Inclusive' : 'Exclusive'}
              </div>
              <div>
                <strong className="block font-medium text-gray-800">
                  Compete Proposal:
                </strong>
                {proposal.competeQuote ? 'Yes' : 'No'}
              </div>
            </div>

            {proposal?.customer?.customerLogoUrl && (
              <div className="my-6">
                <strong className="block font-medium text-gray-800">
                  Customer Logo:
                </strong>
                <img
                  src={proposal.customer.customerLogoUrl}
                  alt="Customer Logo"
                  className="w-32 h-32 mt-2 shadow rounded"
                />
              </div>
            )}
          </div>
        </Container>
      )}

      <Container title="Product List">
        <div className="p-6 bg-white shadow-lg rounded-lg mb-6">
          <ProductList preview={true} />
        </div>
      </Container>

      <div className="mx-40 p-6 bg-white shadow-lg rounded-lg mb-6">
        <StandardTotal preview={true} />
      </div>

      <Container title="Offers and Terms & Conditions">
        <div className="p-6 bg-white shadow-lg rounded-lg">
          {/* Offers Section */}
          <div>
            <strong className="block text-lg font-semibold text-gray-800">
              Offers:
            </strong>
            <ul className="list-disc ml-5 mt-2 text-gray-600">
              {(proposal.offers || []).map((offer, index) => (
                <li key={index} className="mb-1 text-sm">
                  {offer.offer}
                </li>
              ))}
            </ul>
          </div>

          {/* Terms & Conditions Section */}
          <div className="mt-6">
            <strong className="block text-lg font-semibold text-gray-800">
              Terms & Conditions:
            </strong>
            <ul className="list-disc ml-5 mt-2 text-gray-600">
              {(proposal.termAndConditions || []).map((term, index) => (
                <li key={index} className="mb-1 text-sm">
                  {term.termCondition}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>

      <div className="mt-6 flex justify-end space-x-4">
        <button
          className="px-6 py-2 bg-gray-300 text-gray-700 font-semibold rounded-md hover:bg-gray-400"
          onClick={closeModal} // Assuming closeModal takes user back to the edit form
        >
          Back to Edit
        </button>
        {/* <button className="px-6 py-2 bg-green-600 text-white font-semibold rounded-md hover:bg-green-700">
          Submit Proposal
        </button> */}
      </div>
    </div>
  );
};

export default PreviewQuote;
